import { ComponentType, FC } from "react";

import BookOpenOutlineIcon from "@src/lib/icons/18px/book-open-outline";
import BookmarkOutlineIcon from "@src/lib/icons/18px/bookmark-outline";
import CircleCheckmarkOutlineIcon from "@src/lib/icons/18px/circle-checkmark-outline";
import FileTextOutlineIcon from "@src/lib/icons/18px/file-text-outline";
import LawShieldIcon from "@src/lib/icons/18px/law-shield";
import SuitcaseOutlineIcon from "@src/lib/icons/18px/suitcase-outline";
import Tasks2Icon from "@src/lib/icons/18px/tasks-2";
import { IconProps } from "@src/lib/icons/types";
import type { ContentType } from "./ContentAvatar";

export type ContentTypeIconComponent = ComponentType<IconProps>;

/**
 * The single source of truth for which icon represents a content type. Every
 * surface that draws a content type (thumbnails, tabs, nav, menus) should read
 * from here so an icon swap lands everywhere at once.
 *
 * Folders have no icon: they render their own affordance.
 */
export const CONTENT_TYPE_ICON: Record<
  Exclude<ContentType, "Folder">,
  ContentTypeIconComponent
> = {
  Course: BookmarkOutlineIcon,
  Module: BookOpenOutlineIcon,
  PremiumModule: BookOpenOutlineIcon,
  Skill: CircleCheckmarkOutlineIcon,
  Task: Tasks2Icon,
  Audit: LawShieldIcon,
  Resource: FileTextOutlineIcon,
  SCORMCourse: SuitcaseOutlineIcon,
};

type Props = IconProps & {
  contentType: ContentType;
};

const ContentTypeIcon: FC<Props> = ({ contentType, ...props }) => {
  if (contentType === "Folder") return null;
  const Icon = CONTENT_TYPE_ICON[contentType];
  return <Icon {...props} />;
};

export default ContentTypeIcon;
